import { createMockCreator } from '@csp/test-common-utils';
import { noop } from 'lodash';
import { NotificationsContextState } from '../NotificationsContextState';
import { createNotificationMock } from './Notification.mock';

const notificationsContextStateMock: NotificationsContextState = {
  notification: createNotificationMock(),
  removeNotification: noop,
  showNotification: noop,
};

export const createNotificationsContextStateMock = createMockCreator(notificationsContextStateMock);
